import { Container, Text } from '@pixi/react'
import { TextStyle, Container as PixiContainer, Assets } from 'pixi.js'
import { Image, t } from '@slot-nx/core'
import { gameConfig } from '../../config'
import { useEffect, useRef } from 'react'
import { winBarService } from '../../domain/winning/service/winbarService'
import tumbleImg from '../../../asset/images/tumbleBar.png'

Assets.add({
  alias: 'tumbleImg',
  src: tumbleImg,
  loadParser: 'loadTextures',
})

const tumbleTextStyle = new TextStyle({
  fill: '#fcc130',
  fontSize: 36,
  fontWeight: 'bold',
  dropShadow: true,
  dropShadowColor: '#341704',
  dropShadowBlur: 4,
  dropShadowAngle: Math.PI / 4,
  dropShadowDistance: 3,
  stroke: '#c06411',
  strokeThickness: 2,
})
const tumbleWinAmountStyle = new TextStyle({
  fill: '#fcc130',
  fontSize: 46,
  fontWeight: 'bold',
  stroke: '#fcc130',
  strokeThickness: 2,
  letterSpacing: 3,
})

export const TumbleWinBar = () => {
  const tumbleWinBarRef = useRef<PixiContainer>()
  useEffect(() => {
    winBarService.tumbleWinBar = tumbleWinBarRef.current as PixiContainer
    winBarService.tumbleWinBar.alpha = 0
  }, [])
  return (
    <Container
      name="TumbleWinBar"
      anchor={[0.5, 0.5]}
      scale={1}
      width={599}
      height={166}
      x={gameConfig.resolution.width / 2}
      y={125}
      ref={(el: PixiContainer | null) => {
        tumbleWinBarRef.current = el as PixiContainer
      }}
    >
      <Image name="tumbleImg" anchor={0.5} x={0} y={0} image="tumbleImg" scale={1} />

      <Text name="TumbleWinTitle" anchor={[0.5, 0.5]} y={-40} text={t('tumbleWin')} style={tumbleTextStyle} />
      <Text
        name="TumbleWinText"
        anchor={[0.5, 0.5]}
        y={22}
        x={0}
        style={tumbleWinAmountStyle}
      >
      </Text>
      {/* <BitmapText
        name="TumbleWinText"
        text=""
        anchor={[0.5, 0.2]}
        style={{ fontName: 'Font_TBW', fontSize: 26 }}
        x={0}
        y={1.5}
      /> */}
    </Container>
  )
}
